import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type JivoSetupWidgetRequest as SchemaJivoSetupWidgetRequest } from '../schemas/JivoSetupWidgetRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const SetupJivoWidgetContentType = 'application/json' as const;
export type SetupJivoWidgetRequest = SchemaJivoSetupWidgetRequest;
export type SetupJivoWidgetResponses = LinkCommonErrorResponses & {};
export type SetupJivoWidgetResponseSuccess = undefined;
export type SetupJivoWidgetSearchParams = undefined;
export type SetupJivoWidgetPathParameters = undefined;
export const SetupJivoWidgetUrl = '/integrations/jivo/widget' as const;
export const SetupJivoWidgetMethod = 'POST' as const;
export const getSetupJivoWidgetUrl = (_params?: SetupJivoWidgetPathParameters) => SetupJivoWidgetUrl;
